import { render, staticRenderFns } from "./goHome.vue?vue&type=template&id=53d92c22&scoped=true&"
import script from "./goHome.vue?vue&type=script&lang=js&"
export * from "./goHome.vue?vue&type=script&lang=js&"
import style0 from "./goHome.vue?vue&type=style&index=0&id=53d92c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d92c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d92c22')) {
      api.createRecord('53d92c22', component.options)
    } else {
      api.reload('53d92c22', component.options)
    }
    module.hot.accept("./goHome.vue?vue&type=template&id=53d92c22&scoped=true&", function () {
      api.rerender('53d92c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/goHome.vue"
export default component.exports